import type { IxmUserauthV1TenantKeys } from '@interxfi/types/generated/api';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const USERAUTH_TENANT_BASE_PATH = getResolvedPath('/tenant');

export const getUserauthTenantPath: EntityPathBuilder<IxmUserauthV1TenantKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return USERAUTH_TENANT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.tenantId) {
        return undefined;
      }

      return getResolvedPath(`${USERAUTH_TENANT_BASE_PATH}/$tenantId`, context.keys);
    }
  }
};

export function getUserauthTenantDetailPath(tenantId: string | undefined) {
  if (!tenantId) {
    return undefined;
  }

  return getUserauthTenantPath({ kind: 'detail', keys: { tenantId } });
}
